import { IQuestionModel } from '@care-portals/api-interfaces';
import { usStates } from '../../data';

const questionsModels: IQuestionModel[] = [
  /**
   * goodnatal forms
   */
  {
    label:
      'We are so sorry that you are on this journey, but our mission is to support you every step of the way.',
    educationalSlide: `
    Please take a moment to fill out this welcome intake.
    Your answers will be kept confidential and only shared with your practitioner(s), and will play a key part in understanding how to best support.
    Thank you.
.`,
    field: 'gn_q_1',
    type: 'info',
    answer: {}
  },
  {
    // 4
    field: 'gn_q_2',
    label: 'What providers have you seen so far on your journey?',
    subLabel: 'Please select as many as apply',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'OB-GYN', value: 'OB-GYN' },
        {
          key: 'Reproductive endocrinologist',
          value: 'Reproductive endocrinologist'
        },
        {
          key: 'Reproductive immunologist',
          value: 'Reproductive immunologist'
        },
        {
          key: 'Maternal–fetal medicine doctor',
          value: 'Maternal–fetal medicine doctor'
        },
        { key: 'Urologist', value: 'Urologist' },
        { key: 'Therapist', value: 'Therapist' },
        { key: 'Genetic counselor', value: 'Genetic counselor' },
        {
          key: 'Acupuncturist or herbalist',
          value: 'Acupuncturist or herbalist'
        },
        { key: 'Chiropractor', value: 'Chiropractor ' },
        {
          key: 'Someone else',
          value: 'Someone else',
          answer: {
            type: 'text',
            label: 'Please specify'
          }
        }
      ]
    }
  },
  {
    field: 'gn_q_3',
    label: 'How many total pregnancies have you had?',
    type: 'info',
    answer: {
      type: 'number',
      name: 'totalPregnancies',
      size: 'large'
    }
  },
  {
    field: 'gn_q_4',
    label: 'How many pregnancy losses have you experienced?',
    subLabel: 'Select one',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'losses_0', value: '0', halfWidth: true },
        { key: 'losses_1', value: '1', halfWidth: true },
        { key: 'losses_2', value: '2', halfWidth: true },
        { key: 'losses_3', value: '3', halfWidth: true },
        { key: 'losses_4-5', value: '4-5', halfWidth: true },
        { key: 'losses_6', value: '6+', halfWidth: true }
      ]
    }
  },
  {
    field: 'gn_q_5',
    label: 'What type of loss(es) have you experienced?',
    subLabel: 'Please check all that apply',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'Chemical pregnancy', value: 'Chemical pregnancy' },
        {
          key: '1st trimester loss',
          value: 'Miscarriage (1st trimester loss)'
        },
        { key: '2nd term loss', value: '2nd term loss' },
        { key: '3rd term loss', value: '3rd term loss' }
      ]
    }
  },
  {
    field: 'gn_q_7',
    label: 'Have you experienced infertility?',
    subLabel: '(Inability to get pregnant after 1 year of unprotected sex or 6 months if over 35)',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'infertilityYes',
          value: 'Yes'
        },
        {
          key: 'infertilityNo',
          value: 'No'
        }
      ]
    }
  },
  {
    field: 'gn_q_8',
    label: 'Have you undergone any of the following fertility treatments?',
    subLabel: 'Please check all that apply',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'iui', value: 'Intrauterine insemination (IUI)' },
        {
          key: 'ivf',
          value: 'In vitro fertilization (IVF)'
        },
        { key: 'stimulation', value: 'Hormone / ovarian stimulation' }
      ]
    }
  },
  {
    field: 'gn_q_9',
    label:
      'Have you been diagnosed with a medical cause of pregnancy loss or infertility?',
    subLabel:
      'This could include PCOS, blood clotting disorder, endometriosis, luteal phase defect, chromosomal abnormality, etc',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'gn_q_9No',
          value: 'No'
        },
        {
          key: 'gn_q_9Yes',
          value: 'Yes',
          answer: {
            name: 'gn_q_9Yes_more',
            type: 'text',
            placeholder:
              'Which diagnosis or condition?'
          }
        }
      ]
    }
  },
  {
    field: 'gn_relationship',
    label: 'What is your relationship status?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'relationship_single',
          value: 'Single'
        }, {
          key: 'relationship_married',
          value: 'Married'
        }, {
          key: 'relationship_partnered',
          value: 'Partnered'
        }, {
          key: 'relationship_divorced',
          value: 'Divorced'
        }, {
          key: 'relationship_separated',
          value: 'Separated'
        }, {
          key: 'relationship_widowed',
          value: 'Widowed'
        },
      ]
    }
  },
  {
    field: 'gn_counselling_before',
    label: 'Have you participated in therapy / counseling before?',
    type: 'polar_check',
    answer: {
      label: 'Have you ever been diagnosed, treated for, or hospitalized for a mental health condition?',
      name: 'liveBirthsNumber',
      type: 'select',
      options: [
        {
          key: 'gn_counselling_before_yes',
          value: 'Yes',
          answer: {
            label: 'Please explain',
            name: 'gn_counselling_before_yes_desc',
            type: 'text',
            placeholder: 'Please explain'
          }
        }
      ]
    }
  },
  {
    field: 'gn_depression',
    label: 'Do you have symptoms of depression / anxiety?',
    type: 'select',
    answer: {
      label: 'Have you ever been diagnosed, treated for, or hospitalized for a mental health condition?',
      name: 'liveBirthsNumber',
      type: 'single_select',
      options: [
        {
          key: 'gn_depression_yes',
          value: 'Yes'
        },
        {
          key: 'gn_depression_no',
          value: 'No'
        },
        {
          key: 'gn_depression_notsure',
          value: 'Not Sure'
        }
      ]
    }
  },
  {
    field: 'gn_medications',
    label: 'Do you currently take any medications? Please list what and why?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'gn_medications_desc',
    }
  },
  {
    field: 'gn_family_mental_history',
    label: 'Please note any family history of mental health conditions',
    subLabel: '(chemical dependency, mental illness, etc.)',
    type: 'info',
    answer: {
      type: 'text',
      name: 'gn_family_mental_history_desc',
    }
  },
  {
    field: 'gn_q_journey_supported',
    label: 'How supported do you currently feel on your fertility journey?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'Extremely unsatisfied', value: 'Extremely unsatisfied' },
        { key: 'Somewhat unsatisfied', value: 'Somewhat unsatisfied' },
        { key: 'Neutral', value: 'Neutral' },
        { key: 'Somewhat satisfied', value: 'Somewhat satisfied' },
        { key: 'Extremely satisfied', value: 'Extremely satisfied' }
      ]
    }
  },
  {
    field: 'gn_q_anythingelse',
    label: 'Anything else you want to us to know?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'a13',
      required: true,
      placeholder: 'Please describe'
    }
  },
  {
    field: 'gn_q_hear',
    label: 'Finally, how did you hear about us?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'Social media', value: 'Social media' },
        { key: 'Google search', value: 'Google search' },
        { key: 'An article or blog post', value: 'An article or blog post' },
        { key: 'A friend', value: 'A friend' },
        { key: 'Clinic', value: 'Clinic' },
        {
          key: 'Other',
          value: 'Other',
          answer: {
            name: 'a14_other',
            type: 'text',
            placeholder: 'Please specify'
          }
        }
      ]
    }
  },

  ////////////////////////////////
  // post group session questions
  ///////////////////////////////
  {
    field: 'gn_post_1',
    label: 'Overall, how satisfied are you with this support group session?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'Very satisfied', value: 'Very satisfied' },
        { key: 'Satisfied', value: 'Satisfied' },
        { key: 'Neutral', value: 'Neutral' },
        { key: 'Dissatisfied', value: 'Dissatisfied' },
        { key: 'Very dissatisfied', value: 'Very dissatisfied' }
      ]
    }
  },  {
    field: 'gn_post_2',
    label: 'On a scale of 1 to 5, how would you rate your current emotional well-being? (1 being very low/poor, 5 being very high/good?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: '1', value: '1' },
        { key: '2', value: '2' },
        { key: '3', value: '4' },
        { key: '4', value: '4' },
        { key: '5', value: '5' },
      ]
    }
  },{
    field: 'gn_post_3',
    label: 'Compared to before attending the support group, how do you feel about your emotional and mental health?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'Much improved', value: 'Much improved' },
        { key: 'Somewhat improved', value: 'Somewhat improved' },
        { key: 'No change', value: 'No change' },
        { key: 'Somewhat worse', value: 'Somewhat worse' },
        { key: 'Much worse', value: 'Much worse' },
      ]
    }
  },{
    field: 'gn_post_4',
    label: 'What aspect of the support group session did you find most helpful?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'Hearing others\' stories', value: 'Hearing others\' stories' },
        { key: 'Sharing my own story / venting', value: 'Sharing my own story / venting' },
        { key: 'Guidance from the facilitator/therapist', value: 'Guidance from the facilitator/therapist' },
        { key: 'Educational content provided', value: 'Educational content provided' },
        { key: 'The supportive environment ', value: 'The supportive environment ' },
        {
          key: 'Other',
          value: 'Other',
          answer: {
            name: 'a14_other',
            type: 'text',
            placeholder: 'Please specify'
          }
        }
      ]
    }
  },{
    field: 'gn_post_5',
    label: 'How comfortable did you feel sharing your thoughts and experiences in the group?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'Very comfortable', value: 'Very comfortable' },
        { key: 'Comfortable', value: 'Comfortable' },
        { key: 'Neutral', value: 'Neutral' },
        { key: 'Uncomfortable', value: 'Uncomfortable' },
        { key: 'Very uncomfortable', value: 'Very uncomfortable' }
      ]
    }
  },{
    field: 'gn_post_6',
    label: 'How likely are you to recommend this support group to others who have experienced a miscarriage?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'Very likely', value: 'Very likely' },
        { key: 'Likely', value: 'Likely' },
        { key: 'Neutral', value: 'Neutral' },
        { key: 'Unlikely', value: 'Unlikely' },
        { key: 'Very unlikely', value: 'Very unlikely' }
      ]
    }
  },  {
    field: 'gn_post_7',
    label: 'Is there anything that you feel was missing or could be improved in the session, or any additional comments or suggestions?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'gn_medications_desc',
    }
  },  {
    field: 'gn_post_8',
    label:
      'Thank you for taking the time to complete this survey. Your input is greatly appreciated and will help us continue to provide meaningful support.',
    type: 'info',
    answer: {}
  },

  
];

export default questionsModels;
